import { Button } from '@/src/shadComponents/ui/button';
import { Divider } from '@/src/tailwindui/divider';
import { Subheading } from '@/src/tailwindui/heading';
import { Input } from '@/src/tailwindui/input';
import { Text } from '@/src/tailwindui/text';
import DatePickerField from '@/src/Common/components/DatePickerField';
import LocationField from '@/src/Common/components/LocationField';

export default function EventDetailsForm({
    onNext,
    eventName,
    setEventName,
    eventDate,
    setEventDate,
    eventLocation,
    setEventLocation,
    showNextButton = false,
}: {
    onNext: () => void;
    eventName: string;
    setEventName: (eventName: string) => void;
    eventDate: Date | null;
    setEventDate: (eventDate: Date) => void;
    eventLocation: string | null;
    setEventLocation: (eventLocation: string | null) => void;
    showNextButton?: boolean;
}) {
    return (
        <>
            <section className="grid gap-x-8 gap-y-6 sm:grid-cols-2">
                <div className="space-y-1">
                    <Subheading>Name</Subheading>
                    <Text>
                        This is displayed in the event's online gallery.
                    </Text>
                </div>
                <div>
                    <Input
                        aria-label="Event Name"
                        name="event-name"
                        type="text"
                        value={eventName}
                        onChange={(e) => setEventName(e.target.value)}
                        className="monospace-font dark:text-white"
                    />
                </div>
            </section>

            <Divider className="my-10" soft />

            <section className="grid gap-x-8 gap-y-6 sm:grid-cols-2">
                <div className="space-y-1">
                    <Subheading>Date</Subheading>
                    <Text></Text>
                </div>
                <div>
                    <DatePickerField
                        date={eventDate ?? new Date()}
                        onChange={(date: Date) => {
                            setEventDate(date ?? new Date());
                        }}
                    />
                </div>
            </section>

            <Divider className="my-10" soft />

            <section className="grid gap-x-8 gap-y-6 sm:grid-cols-2">
                <div className="space-y-1">
                    <Subheading>Location</Subheading>
                    <Text>Which city is the event being held in?</Text>
                </div>
                <div>
                    <LocationField
                        className="block flex-1 border-0 bg-transparent py-1.5 pl-1 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6 dark:text-white"
                        name="location"
                        value={eventLocation}
                        onChange={(e: any) => setEventLocation(e.target.value)}
                    />
                </div>
            </section>

            <div className="my-10" />
            {showNextButton && (
                <div className="flex justify-end gap-4 select-none">
                    {/* @ts-ignore */}
                    <Button
                        className="mt-4 dark-button disabled:opacity-50 select-none"
                        onClick={() => {
                            onNext();
                        }}
                    >
                        Next&nbsp;&nbsp;&nbsp;&nbsp;
                        <span className="animate-bounce rotate-90">&uarr;</span>
                        &nbsp;&nbsp;&nbsp;
                    </Button>
                </div>
            )}
        </>
    );
}
